<template>
    <div v-loading="!finishGetList">
        <elastic-filter-link :filterLayout="filterLayout" :sortData="filterSet.sort"
                             :filterData="filterSet.filter" :paginationData="filterSet.page"></elastic-filter-link>
        <elastic-list-link :listLayout="listLayout" :elasticData="List" :paginationData="filterSet.page" :sortData="filterSet.sort"
                           ref="elasticListLink"></elastic-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                         :finishGetList="finishGetList" :listLength="List.length"></pagination-link>

        <item-display-modify-modal :selectItems="selectRow"></item-display-modify-modal>
    </div>

</template>

<script>
import elasticUtil from "@/components/elastic/elasticUtil";
import ElasticFilterLink from "@/components/elastic/ElasticFilterLink";
import ElasticListLink from "@/components/elastic/ElasticListLink";
import PaginationLink from "@/components/elastic/PaginationLink";
import EventBus from "@/mixins/event-bus";
import listMixins from "@/mixins/listMixins";
import filterMixins from "@/mixins/filterMixins";
import util from "@/mixins/util";
import VuxAlert from "@/mixins/alertMixins"
import {mapGetters, mapState} from "vuex";
import ItemDisplayModifyModal from '@/components/modal/ItemDisplayModifyModal'
import {elasticOption} from "@/api/config";
import {isDev} from "@/api/config";

const {filterConfig, elasticDefaultBody} = elasticUtil;
export default {
    name: "ElasticListComponent",
    components: {ElasticFilterLink, ElasticListLink, PaginationLink, ItemDisplayModifyModal},
    mixins: [elasticUtil, filterMixins, listMixins, VuxAlert],
    inject: [],
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            setFilterNotParser: this.setFilterNotParser,
            resetFilter: this.resetFilter,
            elasticListSetData: this.setData,
            setSort: this.setSort,
            setSortNotParser: this.setSortNotParser,
            elasticListUpdate: this.updateConfirm,
            elasticListDelete: this.openDeleteConfirm,
            elasticListDisplay: this.openDisplayModal,
            itemDisConnect: this.itemDisConnect,
            itemConnect: this.itemConnect,
        }
    },
    props: {
        elasticType: '',
        defaultFilter: {default: () => {}},
        brandKey : {default: () => 0},
    },
    data() {
        return {
            filterLayout: '',
            listLayout: '',
            paginationLayout: '',
            page: 0,
            pageRow: 10,
            paginationType: 'firstInitPage',
            listApiParamSet: {},
            sortOptions: {},
            startSort: null,
            listUpdateData: [],

            isFirstGet: true,
            selectRow: [],
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
    },
    mounted() {
        EventBus.$on('elasticListGetList', this.getList)
    },
    beforeDestroy() {
        EventBus.$off('elasticListGetList')
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
            data: state => state.common.data,
        }),
    },
    methods: {
        initConfig() {
            let config = this.returnElasticConfig(this.elasticType);
            this.filterLayout = config.filterLayout;
            this.listLayout = config.listLayout;
            this.paginationLayout = config.paginationLayout;
            this.paginationType = config.paginationType;
            this.sortOptions = config.sortOptions;
            this.startSort = config.startSort;
            this.isGetFirst = config.isGetFirst;
            this.getTypeFunc = config.getTypeFunc;
            this.getTypeParamSet = config.getTypeParamSet;
            this.listUpdateData = config.listUpdateData;


            if (!util.isEmpty(config.listApiParamSet)) {
                this.listApiParamSet = JSON.parse(JSON.stringify(config.listApiParamSet));
            }
            if (!util.isEmpty(config.isFirstGet)) {
                this.isFirstGet = config.isFirstGet;
            }

            this.settingSortOptions();

            let listOptions = {
                index :elasticOption.index,
                type : elasticOption.type
            };

            if (!util.isEmpty(this.listApiParamSet)) {
                listOptions.defaultBody = Object.assign({}, this.listApiParamSet, this.defaultFilter);
            }

            this.setDefaultPageSize();
            this.initList('elastic', listOptions);
            this.setFilterConfig(filterConfig);
            if(this.elasticType == 'modalSelect'){
                this.setParserType('vuex', this.$route.fullPath);
            }else {
                this.setParserType('url', this.$route.fullPath);
            }

            if (this.isFirstGet) {
                this.getList(true)
            }
        },
        getList(isFirst=false) {
            this.finishGetList = false;
            EventBus.$emit('apiLoading', true);
            try {

                let filterSet = JSON.parse(JSON.stringify(this.getFilterSet()));
                if(isFirst && this.paginationType === 'lazyload' && this.parserType === 'url' || (isFirst && this.paginationType === 'firstInitPage')) {
                    filterSet.page.page = 1;
                    this.filterSet.page.page = 1;
                    this.List = [];
                    this.setPage('page', 1)
                }else if(isFirst && this.paginationType != 'lazyload' ) {
                    let parsingDataPage = this.getPasingDataPage();
                    filterSet.page.page = parsingDataPage;
                    this.List = [];
                }else if(this.isInitPage === true) {
                    filterSet.page.page = 1;
                    this.filterSet.page.page = 1;
                }

                if(this.listClass === null) {
                    return false;
                }
                if(this.isInitPage === true && !this.isGetFirst && util.isEmpty(filterSet.filter)) {
                    this.List = [];
                    return false;
                }
                this.listClass.getList(filterSet, this.isInitPage).then(res => {
                    let list = res.list.slice();
                    if(this.paginationType === 'lazyload' && filterSet.page.page > 1) {
                        this.List = this.List.concat(list);
                    }else{
                        this.List = list;
                    }
                    if(res.hasOwnProperty('total')) {
                        this.setPage('total', res.total);
                    }
                    if(isFirst && !(this.paginationType === 'lazyload' || this.paginationType === 'firstInitPage')) {
                        this.setParsingDataPageFilterSet();
                    }
                    if(this.isInitPage) {
                        this.setPage('page', 1);
                        this.isInitPage = false;
                    }
                    this.finishGetList = true;
                    if(!this.isGet) {
                        this.isGet = true;
                    }
                    EventBus.$emit('apiLoading', false);
                    if(!util.isEmpty(this.listUpdateData)) {
                        util.Array.each(this.List, (data, index, arr) => {
                            util.Array.each(this.listUpdateData, (updateKey, index, arr) => {
                                if(data.hasOwnProperty(updateKey)) {
                                    data[`${updateKey}_update`] = data[updateKey]
                                }
                            })
                        })
                    }
                    this.selectRow = [];
                    return true;
                })
            }catch (e) {
                console.log(e);
            }
        },
        setData(key, value) {
            this[key] = value;
        },
        setDefaultPageSize() {
            let config = this.returnElasticConfig(this.elasticType);
            if (config.pageRow && config.pageRow != this.filterSet.page.size) {
                this.pageRow = config.pageRow;
                this.filterSet.page.size = config.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }
        },
        settingSortOptions() {
            if (!util.isEmpty(this.sortOptions) && util.isObject(this.sortOptions)) {
                let inputSortOptions = JSON.parse(JSON.stringify(this.sortOptions));
                this.sortOptions = inputSortOptions;
                this.setSortOptions(inputSortOptions, this.startSort);

            }
        },

        isCheckUpdate(rows=[]) {
            if(util.isEmpty(this.listUpdateData)) {
                return false;
            }
            let isAllChange = true;
            util.Array.each(rows, (data, index, arr) => {
                let isChange = false;
                util.Array.each(this.listUpdateData, (updateKey, index, arr) => {
                    if(data[updateKey] !== data[`${updateKey}_update`]) {
                        isChange = true;

                    }
                })
                if(!isChange) {
                    isAllChange = false;
                }
            })
            return isAllChange
        },

        updateConfirm(items=[]) {
            let selected = items;
            if(items === 'selected') {
                selected = this.selectRow.slice();
            }
            if(selected.length < 1) {
                this.errorAlert('1개 이상 선택해주세요.')
                return false;
            }
            let confirmContent = '수정된 정보를 저장하시겠습니까?';
            if (!this.isCheckUpdate(selected)) {
                confirmContent = '수정되지 않은 정보가 있습니다.<br>이대로 저장하시겠습니까?';
            }
            this.createConfirm({
                content: confirmContent,
                confirmText: '저장',
                confirm: () => {
                    this.updateItem(selected, 0);
                },
            })
        },
        makeUpdateParams(item={}) {
            let params = {
                i_type: 'eot',
                i_idx: item.i_idx,
            }
            util.Array.each(this.listUpdateData, (updateKey, index, arr) => {
                params[updateKey] = item[`${updateKey}_update`]
            })
            return params;
        },
        updateItem(items, index = 0) {
            this.tableLoading = true;
            EventBus.$emit('changeLoading', true);
            let params = this.makeUpdateParams(items[index]);
            try {
                this.$api.$item.updateItem(params).then(res => res.Data.Result).then(res => {
                    if (res.List.Data.Data.Basic.Status === true) {
                        let indexingParams = {
                            i_idx: items[index].i_idx,
                            index: elasticOption.index
                        }
                        this.$api.$item.indexingItem(indexingParams).then(elaRes => {
                            if (elaRes.Data.Result.Info.Type != 1) {
                                let alertContent = `전체 ${items.length}개의 상품중에 ${index}개가 수정되었습니다.`;
                                if (index === 0 && items.length === 1) {
                                    alertContent = '상품 수정에 실패하였습니다.'
                                }
                                this.updateFinishAlert(alertContent);
                            } else {
                                if (index + 1 === items.length) {
                                    EventBus.$emit('changeLoading', false);
                                    this.updateFinishAlert('상품 수정이 완료되었습니다.');
                                } else {
                                    this.updateItem(items, index + 1);
                                }
                            }
                        })
                    } else {
                        let alertContent = `전체 ${items.length}개의 상품중에 ${index}개가 수정되었습니다.`;
                        if (index === 0 && items.length === 1) {
                            alertContent = '상품 수정에 실패하였습니다.'
                        }
                        this.updateFinishAlert(alertContent);
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
        updateFinishAlert(content) {
            this.createAlert({
                title: '',
                content: content,
                btnText: "확인",
                hide: () => {
                    this.getList();
                }
            });
        },
        openDeleteConfirm(items=[]) {
            let selected = items;
            if(items === 'selected') {
                selected = this.selectRow.slice();
            }
            if(selected.length < 1) {
                this.errorAlert('1개 이상 선택해주세요.')
                return false;
            }
            let idList = [];
            selected.forEach((row, index) => {
                idList.push(row.i_idx);
                /*idList += row.i_idx;
                if (index < this.selectRow.length - 1) {
                    idList += ','
                }*/
            })
            let alertParams = {'element': this, 'key': idList, id: this.UserInfo.mb_id};
            this.listDeleteInputConfirm(alertParams);
        },

        dataDelete(keys, password) {
            this.tableLoading = true;
            let params = {
                i_type: 'eot',
                i_idx: keys
            }
            this.$api.$item.deleteItem(params).then(res => res.Data.Result).then(res => {
                if (res.List.Data.Status) {
                    // this.deleteAlert({element: this});
                    let deleteKeys = keys;
                    this.productElaIndexing('삭제', deleteKeys);
                    /*let deleteKeys = keys.split(',');
                    this.productElaIndexing('삭제', deleteKeys);*/
                    // if(!isDev) {
                    //     this.productElaIndexing('삭제', deleteKeys);
                    // }else {
                    //     this.createAlert({
                    //         content: alertTxt.content,
                    //         btnText: "확인",
                    //         hide: () => {
                    //             EventBus.$emit('apiLoading', true);
                    //             setTimeout(() => {
                    //                 this.getList();
                    //             }, 800)

                    //         }
                    //     });
                    // }
                } else {
                    this.errorAlert('전체 삭제 실패');
                }
                this.getList();
            })
        },
        productElaIndexing(contentText, indexingList) {
            let alertTxt = {
                title: '',
                content: `${contentText} 성공`
            };
            let cnt = 0;
            let tryCnt = 0;
            indexingList.forEach(row => {
                cnt++;
                let param = {
                    i_idx: row,
                    index: elasticOption.index,
                }
                this.$api.$item.indexingItem(param).then(res => {
                    tryCnt++;
                    if (res.Data.Result.Info.Type != 1) {
                        alertTxt.content = `${contentText} 실패`
                        return false;
                    }
                    if (cnt == tryCnt) {
                        this.createAlert({
                            content: alertTxt.content,
                            btnText: "확인",
                            hide: () => {
                                EventBus.$emit('apiLoading', true);
                                setTimeout(() => {
                                    this.getList();
                                }, 800)
                            }
                        });
                    }
                })
            })
        },
        openDisplayModal(items=[]) {
            let selected = items;
            if(items === 'selected') {
                selected = this.selectRow.slice();
            }
            if(selected.length < 1) {
                this.errorAlert('1개 이상 선택해주세요.')
                return false;
            }
            this.$modal.show('item-display-modify-modal')
        },
        itemDisConnect(){
            let selected = this.selectRow.slice();
            if(selected.length < 1) {
                this.errorAlert('1개 이상 선택해주세요.')
                return false;
            }
            this.tableLoading = true;
            let params = {i_idx:[]};
            util.Array.each(selected, (data, index, arr) => {
                params.i_idx.push(data.i_idx);
            })
            try {
                this.$api.$brand.brandDisconnect(params).then(res => res.Data.Result).then(res => {
                    let alertContent='';

                    if (res.Info.Type === 1) {
                        alertContent = `연결 해제되었습니다.`;
                    } else {
                        alertContent = '연결 해제에 실패하였습니다.'
                    }
                    this.runElasticIndexing(params.i_idx, 0).then(res => {
                        this.updateFinishAlert(alertContent);
                    })
                })
            } catch (e) {
                console.log(e);
            }
        },
        itemConnect(items){
            let params = {
                i_idx:[],
                b_idx: this.brandKey,
            };
            util.Array.each(items, (data, index, arr) => {
                params.i_idx.push(data.i_idx);
            })
            try {
                this.$api.$brand.brandConnect(params).then(res => res.Data.Result).then(res => {
                    let alertContent='';
                    if (res.Info.Type === 1) {
                        alertContent = `연결 되었습니다.`;
                    } else {
                        alertContent = '연결에 실패하였습니다.'
                    }
                    this.runElasticIndexing(params.i_idx, 0).then(res => {
                        this.updateFinishAlert(alertContent);
                    })

                })
            } catch (e) {
                console.log(e);
            }
        },
        runElasticIndexing(arr, index) {
            let key = arr[index];
            let param = {
                i_idx : key,
                index : elasticOption.index
            }
            return this.$api.$item.indexingItem(param).then(res => {
                if(arr.length-1 == index) {
                    return true;
                }else {
                    this.runElasticIndexing(arr, index+1);
                }
            })
        },
    },
    watch: {
    },
}
</script>

<style scoped>

</style>
